var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "form_label", class: { required: _vm.innerRequired } },
    [_vm._v(_vm._s(_vm.innerRequired ? "必須" : "任意"))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }